module Meevo.Plugins.OnlineBookingSettings {
    import SettingsDto = Meevo.Model.SettingsDto;
    "use strict";

    /**
    * Services Section of OnlineBooking Settings 
    */
    export class OnlineBookingServicesSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        private serviceIds: string[] = [];
        private selectAll: boolean = false;

        public serviceBaseCriteria = {
            includeActive: true,
            includeInactive: false,
            view: Model.ServiceSearchView.Default,
            selectModelBy: (item) => item['allowBookOnline']
        };

        public LocationServiceCriteria = {
            ...this.serviceBaseCriteria,
            ...{ view: Model.ServiceSearchView.LocationOwned }
        };

        public COServiceCriteria = {
            ...this.serviceBaseCriteria,
            ...{ view: Model.ServiceSearchView.CentralOfficeOwned }
        };

        public activate(): void {
            this.isLoaded = true;
            this.model.onlineBookingServices = {
                serviceCategoryIds: [],
                selectedServicesGuidList: [],
                selectedCOServicesGuidList: []
            };
        }

        public preSave(): any {
            this.serviceIds = this.model.onlineBookingServices.selectedServicesGuidList || this.model.onlineBookingServices.selectedCOServicesGuidList;

            return this.dataService.customMethodData(`/api/Service/AllowBookOnline`, 'PATCH', {
                servicesAllowBookOnline: this.serviceIds,
                selectAll: this.selectAll
            }).then((res: any) => { return this.model; })
              .catch(err => this.serviceIds = []);
         }
    }
}